import { render, staticRenderFns } from "./PrintProfile.vue?vue&type=template&id=28f31047&"
import script from "./PrintProfile.vue?vue&type=script&lang=js&"
export * from "./PrintProfile.vue?vue&type=script&lang=js&"
import style0 from "./PrintProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports